'use strict';

import {map, valuesIn} from 'lodash';
import React, {PropTypes} from 'react';
import { connect } from 'react-redux';
import { monthYear } from '../../../lib/prettyDate';

@connect((state, props) => {
  const employmentGaps = state.employmentGaps;

  return  {
    employmentGaps,
    updateTempState: props.updateTempState,
    script: props.script
  };
})
export default class EmploymentGapsSummary extends React.Component {
  static propTypes = {
    employmentGaps: PropTypes.object,
    updateTempState: PropTypes.func,
    script: PropTypes.bool
  }

  constructor(props) {
    super(props);
  }

  render() {
    const gaps = valuesIn(this.props.employmentGaps);
    return (
      <div className='expanded-accordion-content explanation-of-wahve'>
      <div className='summary-container'>
        <ul>
          <li className='summary-row'>
            <div className='summary-row-item'>Start Date</div>
            <div className='summary-row-item'>End Date</div>
            <div className='summary-row-item explanation'>Gap Explanation</div>
          </li>
          {
            map(gaps, gap =>
              <li className='summary-row'>
                <div className='summary-row-item'>{monthYear(gap.gapStart)}</div>
                <div className='summary-row-item'>{monthYear(gap.gapEnd)}</div>
                <div className='summary-row-item explanation'>{gap.explanation}</div>
              </li>
            )
          }
          {
            (gaps.length === 0)
            &&
            <li className='summary-row'>
              <div className='summary-row-item-empty'>No employment gaps have been entered.</div>
            </li>
          }
        </ul>
      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/applicant/EmploymentGapsSummary/index.js